// src/features/media/components/ClipToolModal.tsx

import { Modal } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import { useNavigate } from '@tanstack/react-router';
import { bcLong } from '@lib2/model/util/string/BaseConverter';
import { ClipToolContent } from './ClipToolContent';
import type { VideoViewData } from '@/lib/types/Media';

interface ClipToolModalProps {
  opened: boolean;
  onClose: () => void;
  video: VideoViewData;
}

export function ClipToolModal({ opened, onClose, video }: ClipToolModalProps) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const navigate = useNavigate();

  const handleSuccess = (newVideo: VideoViewData) => {
    const displayId = bcLong.getStr(newVideo.media.mediaId);

    notifications.show({
      title: 'Clip Created',
      message: `"${newVideo.media.title}" is being processed`,
      color: 'green',
    });

    onClose();

    // Navigate to the new clip's detail page
    navigate({ to: '/videos/$id', params: { id: displayId } });
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Create Clip"
      size="xl"
      fullScreen={isMobile ?? false}
      closeOnClickOutside={false}
      zIndex={400}
    >
      <ClipToolContent
        video={video}
        onSuccess={handleSuccess}
        onCancel={onClose}
      />
    </Modal>
  );
}
